import { render, staticRenderFns } from "./home_h5.vue?vue&type=template&id=56e8436c&scoped=true"
import script from "./home_h5.vue?vue&type=script&lang=js"
export * from "./home_h5.vue?vue&type=script&lang=js"
import style0 from "./home_h5.vue?vue&type=style&index=0&id=56e8436c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e8436c",
  null
  
)

export default component.exports